import { Head } from '@inertiajs/react'
import { TestComponent } from '../../components/TestComponent'

export default function Test() {
  return (
    <>
      <Head title="Test Component" />
      <div className="min-h-screen bg-gray-100 py-12">
        <TestComponent />
      </div>
    </>
  )
}
